export default __webpack_public_path__ + "static/media/12-100.30ffafd4.jpg";